import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { logger } from "@/lib/logger";
import { useAuth } from "@/context/AuthContext";

export default function Subscriptions() {
  const { user } = useAuth();
  const [plans, setPlans] = useState([]);
  useEffect(() => { api.get("/subscription-plans").then(r => setPlans(r.data)).catch(e => logger.error(e)); }, []);
  const subscribe = async (plan) => {
    if (!user) { toast.error("Please sign in to subscribe"); return; }
    try {
      const { data } = await api.post("/subscriptions/subscribe", { plan_id: plan.id, origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (e) { toast.error(e.response?.data?.detail || "Subscribe failed"); }
  };
  return (
    <section className="max-w-[1400px] mx-auto px-6 py-16" data-testid="subs-root">
      <p className="text-xs font-mono tracking-[0.3em] uppercase text-[#C5A059]">Recurring Print Plans</p>
      <h1 className="font-serif text-5xl md:text-6xl mt-3">Subscribe & save.</h1>
      <p className="mt-6 text-[#555] max-w-xl">Set your print calendar on autopilot. We produce, package, and ship on schedule — you focus on the business.</p>
      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {plans.map(p => (
          <div key={p.id} className="border border-[#E5E5E5] p-6 flex flex-col" data-testid={`sub-plan-${p.id}`}>
            <p className="text-[10px] font-mono uppercase tracking-widest text-[#C5A059]">{p.product_type.replace(/_/g," ")}</p>
            <h3 className="font-serif text-2xl mt-2">{p.name}</h3>
            <p className="font-mono text-3xl text-[#0a0a0a] mt-4">${p.price_monthly.toFixed(0)}<span className="text-sm text-[#888]">/mo</span></p>
            <p className="text-sm text-[#555] mt-4 flex-1">{p.description}</p>
            <p className="text-xs text-[#888] font-mono mt-3">Up to {p.quantity_per_month} pieces / month</p>
            <button onClick={() => subscribe(p)} data-testid={`sub-subscribe-${p.id}`} className="mt-6 bg-[#0a0a0a] text-white px-6 py-3 text-xs tracking-[0.25em] uppercase font-bold hover:bg-[#C5A059] hover:text-[#0a0a0a]">Subscribe</button>
          </div>
        ))}
      </div>
      <p className="mt-8 text-xs font-mono text-[#888]">First month via one-time Stripe checkout. Recurring Stripe subscriptions activate automatically once your card is on file — cancel any time from your dashboard.</p>
    </section>
  );
}
